import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=427d6e8b&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('427d6e8b')) {
      api.createRecord('427d6e8b', component.options)
    } else {
      api.reload('427d6e8b', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=427d6e8b&", function () {
      api.rerender('427d6e8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BYkyZ1tX9mmR/JS/cancellationPolicy.vue"
export default component.exports